
export const VALUE_TYPE = "VALUE_TYPE";
export const NUMBER = "NUMBER";
export const TEXT = "TEXT";
export const MAX_DATE = "MAX_DATE";
export const MIN_DATE = "MIN_DATE";
export const DATE_ALLOWED = "DATE_ALLOWED";
export const DATE_NOT_ALLOWED = "DATE_NOT_ALLOWED";
export const WEEKEND_NOT_ALLOWED ="WEEKEND_NOT_ALLOWED";
export const NUMBER_VALUE_EQUAL = "NUMBER_VALUE_EQUAL";
export const NUMBER_VALUE_LESS_THAN = "NUMBER_VALUE_LESS_THAN";
export const NUMBER_VALUE_LESS_THAN_AND_EQUAL =
  "NUMBER_VALUE_LESS_THAN_AND_EQUAL";
export const NUMBER_VALUE_GREATER_THAN = "NUMBER_VALUE_GREATER_THAN";
export const NUMBER_VALUE_GREATER_THAN_AND_EQUAL =
  "NUMBER_VALUE_GREATER_THAN_AND_EQUAL";
export const DIGIT_COUNT = "DIGIT_COUNT"
export const VALUE_SHOULD_BE_BETWEEN = "VALUE_SHOULD_BE_BETWEEN";

export const CURRENCY_VALUE_EQUAL = "CURRENCY_VALUE_EQUAL";
export const CURRENCY_VALUE_NOT_EQUAL = "CURRENCY_VALUE_NOT_EQUAL";
export const CURRENCY_VALUE_LESS_THAN = "CURRENCY_VALUE_LESS_THAN";
export const CURRENCY_VALUE_LESS_THAN_AND_EQUAL = "CURRENCY_VALUE_LESS_THAN_AND_EQUAL";
export const CURRENCY_VALUE_GREATER_THAN = "CURRENCY_VALUE_GREATER_THAN";
export const CURRENCY_VALUE_GREATER_THAN_AND_EQUAL = "CURRENCY_VALUE_GREATER_THAN_AND_EQUAL";

export const MAX_TIME = "MAX_TIME";
export const MIN_TIME = "MIN_TIME";
export const TIME_ALLOWED = "TIME_ALLOWED";
export const TIME_NOT_ALLOWED = "TIME_NOT_ALLOWED";
export const MAX_DATE_TIME = "MAX_DATE_TIME";
export const MIN_DATE_TIME = "MIN_DATE_TIME";
export const DATE_TIME_ALLOWED = "DATE_TIME_ALLOWED";
export const DATE_TIME_NOT_ALLOWED = "DATE_TIME_NOT_ALLOWED";
export const TEXT_EQUAL = "TEXT_EQUAL";
export const TEXT_CONTAINS = "TEXT_CONTAINS";
export const TEXT_DOES_NOT_CONTAINS = "TEXT_DOES_NOT_CONTAINS";
export const TEXT_MAX_LENGTH = "TEXT_MAX_LENGTH";
export const TEXT_MIN_LENGTH = "TEXT_MIN_LENGTH";
export const EMAIL = "EMAIL";
export const PHONE_NUMBER = "PHONE_NUMBER";
export const URL = "URL";
export const REGULAR_EXPRESSION = "REGULAR_EXPRESSION";
export const CONTAINS = "CONTAINS";
export const DOESNT_CONTAIN = "DOESNT_CONTAIN";
export const MATCHES = "MATCHES";
export const DOESNT_MATCH = "DOESNT_MATCH";

export const RANGE = "RANGE";
export const DIGITS = "DIGITS";
export const VALUES = "VALUES";
export const MIN_OPTION = "MIN_OPTION";
export const MAX_OPTION = "MAX_OPTION";
export const SUFFIX_CONTAINS_RULE = "SUFFIX_CONTAINS_RULE";
export const PREFFIX_CONTAINS_RULE = "PREFFIX_CONTAINS_RULE";

type FieldRuleKeyType = {
  name: string;
  title: string;
  type: string;
  isRequired: boolean;
};

interface IFieldRuleDetails {
  title: string;
  defaultErrorMessage: string;
  keys?: {
    [ruleFieldKey: string]: FieldRuleKeyType;
  };
}

export type FieldRulesDetailsType = {
  [rule: string]: IFieldRuleDetails;
};

export const FieldRulesDetails: FieldRulesDetailsType = {
 
  VALUE_TYPE: {
    title: "Value Type",
    defaultErrorMessage: "",
  },
  NUMBER: {
    title: "Number",
    defaultErrorMessage: "Value should be of Number type",
  },
  TEXT: {
    title: "Text",
    defaultErrorMessage: "Value should be of text type",
  },
  PREFFIX_CONTAINS_RULE: {
    title: "Preffix",
    defaultErrorMessage: "Value should Contain Preffix",
  },
  SUFFIX_CONTAINS_RULE: {
    title: "Suffix",
    defaultErrorMessage: "Value should Contain Suffix",
  },
  EMAIL: {
    title: "Email",
    defaultErrorMessage: "Value should be of Email type",
  },
  PHONE_NUMBER: {
    title: "Phone Number",
    defaultErrorMessage: "Value should be of Number type",
  },

  URL: {
    title: "URL",
    defaultErrorMessage: "Value should be of URL type",
  },
  REGULAR_EXPRESSION: {
    title: "Regular expression",
    defaultErrorMessage: "Value should be of Regular expression type",
  },

  CONTAINS: {
    title: "Contains",
    defaultErrorMessage: "Value should Contains",
  },
  DOESNT_CONTAIN: {
    title: "Doesn't Contain",
    defaultErrorMessage: "Value should Doesn't Contains",
  },
  MATCHES: {
    title: "Matches",
    defaultErrorMessage: "Value should Matches",
  },
  DOESNT_MATCH: {
    title: "Doesn't Match",
    defaultErrorMessage: "Value should Doesn't Matches",
  },

  NUMBER_VALUE_EQUAL: {
    title: "Number value equal",
    defaultErrorMessage: "Value should Number value equal",
  },

  NUMBER_VALUE_LESS_THAN: {
    title: "Number value less than",
    defaultErrorMessage: "Number value less than",
  },
  NUMBER_VALUE_LESS_THAN_AND_EQUAL: {
    title: "Number value less than and equal",
    defaultErrorMessage: "Number value less than and equal",
  },
  NUMBER_VALUE_GREATER_THAN: {
    title: "Number value greater than",
    defaultErrorMessage: "Number value greater than",
  },
  NUMBER_VALUE_GREATER_THAN_AND_EQUAL: {
    title: "Number value greater than and equal",
    defaultErrorMessage: "Number value greater than and equal",
  },
  DIGIT_COUNT: {
    title: "Value length should be",
    defaultErrorMessage: "Value length is not equal",
  },
  VALUE_SHOULD_BE_BETWEEN: {
    title: "Number value should be between",
    defaultErrorMessage: "Number value should be between",
  },

  CURRENCY_VALUE_EQUAL: {
    title: "Currency value equal",
    defaultErrorMessage: "Currency value Should Be ",
  },

  CURRENCY_VALUE_NOT_EQUAL: {
    title: "Currency value Not Equal",
    defaultErrorMessage: "Currency should Not equal",
  },

  CURRENCY_VALUE_LESS_THAN: {
    title: "Currency value less than",
    defaultErrorMessage: "Currency value less than",
  },
  CURRENCY_VALUE_LESS_THAN_AND_EQUAL: {
    title: "Currency value less than and equal",
    defaultErrorMessage: "Currency value less than and equal",
  },
  CURRENCY_VALUE_GREATER_THAN: {
    title: "Currency value greater than",
    defaultErrorMessage: "Currency value greater than",
  },
  CURRENCY_VALUE_GREATER_THAN_AND_EQUAL: {
    title: "Currency value greater than and equal",
    defaultErrorMessage: "Currency value greater than and equal",
  },

  MIN_TIME: {
    title: "Min Time",
    defaultErrorMessage: "Time Should be After",
  },
  MAX_TIME: {
    title: "Max Time",
    defaultErrorMessage: "Time Should be Before",
  },
  TIME_ALLOWED: {
    title: "Time Allowed",
    defaultErrorMessage: "Time Should Be ",
  },
  TIME_NOT_ALLOWED: {
    title: "Time Not Allowed",
    defaultErrorMessage: "Time Should Not Be",
  },
  MIN_DATE_TIME: {
    title: "Min Date Time",
    defaultErrorMessage: "Date Time Should be After",
  },
  MAX_DATE_TIME: {
    title: "Max Date Time",
    defaultErrorMessage: "Date Time Should be Before",
  },
  DATE_TIME_ALLOWED: {
    title: "Date Time Allowed",
    defaultErrorMessage: "Date Time Should Be ",
  },
  DATE_TIME_NOT_ALLOWED: {
    title: "Date Time Not Allowed",
    defaultErrorMessage: "Date Time Should Not Be",
  },
  TEXT_EQUAL: {
    title: "Text equal to",
    defaultErrorMessage: "Value should be equal to the specified value",
  },
  TEXT_CONTAINS: {
    title: "Text should contain",
    defaultErrorMessage: "Value should contain the specified value",
  },
  TEXT_DOES_NOT_CONTAINS: {
    title: "Text should not contain",
    defaultErrorMessage: "Value should not contain the specified value",
  },
  TEXT_MAX_LENGTH: {
    title: "Maximum Text Length",
    defaultErrorMessage: "Maximum Text Length",
  },
  TEXT_MIN_LENGTH: {
    title: "Minimum Text Length",
    defaultErrorMessage: "Minimum Text Length",
  },
  MIN_DATE: {
    title: "Min Date",
    defaultErrorMessage: "Date Should be After",
  },
  MAX_DATE: {
    title: "Max Date",
    defaultErrorMessage: "Date Should be Before",
  },
  DATE_ALLOWED: {
    title: "Date Allowed",
    defaultErrorMessage: "Select Date",
  },
  DATE_NOT_ALLOWED: {
    title: "Date Not Allowed",
    defaultErrorMessage: "Not Allowed To Select This Date",
  },
  WEEKEND_NOT_ALLOWED: {
    title: "WeekEnd Not Allowed",
    defaultErrorMessage: "WeekEnd Not Allowed To Select",
  },
  RANGE: {
    title: "Range",
    defaultErrorMessage: "",
  },

  DIGITS: {
    title: "Digits",
    defaultErrorMessage: "",
    // keys: [
    //     {

    //     "name": "min",

    //     "title": "Min Digit",

    //     "type": "int",

    //     "isRequired": true

    //     },

    //     {

    //     "name": "max",

    //     "title": "Max Digit",

    //     "type": "int",

    //     "isRequired": true

    //     }

    // ]
  },

  MAX_OPTION: {
    title: "Max Option",
    defaultErrorMessage: "Select Less Than Max Option",
  },
  MIN_OPTION: {
    title: "Min Option",
    defaultErrorMessage: "Select Min Number Option",
  },

  VALUES: {
    title: "Values",
    defaultErrorMessage: "",
  },
  
};

export const FieldRulesStructure = {

  TEXT_INPUT: {
    isUpfrontRule: true,
    ruleType: VALUE_TYPE,
    isMultipleRule: true,

    options: [NUMBER, TEXT, EMAIL, PHONE_NUMBER, URL, REGULAR_EXPRESSION, SUFFIX_CONTAINS_RULE, PREFFIX_CONTAINS_RULE],

    NUMBER: [
      NUMBER_VALUE_EQUAL,
      NUMBER_VALUE_LESS_THAN,
      NUMBER_VALUE_LESS_THAN_AND_EQUAL,
      NUMBER_VALUE_GREATER_THAN,
      NUMBER_VALUE_GREATER_THAN_AND_EQUAL,
      DIGIT_COUNT,
    ],

    TEXT: [TEXT_EQUAL, TEXT_CONTAINS, TEXT_DOES_NOT_CONTAINS, TEXT_MAX_LENGTH],

    EMAIL: [EMAIL],

    PHONE_NUMBER: [PHONE_NUMBER],

    URL: [URL],

    REGULAR_EXPRESSION: [CONTAINS, DOESNT_CONTAIN, MATCHES, DOESNT_MATCH],

    SUFFIX_CONTAINS_RULE: [SUFFIX_CONTAINS_RULE],
    
    PREFFIX_CONTAINS_RULE: [PREFFIX_CONTAINS_RULE],
  },

  DATE_PICKER: {
    isUpfrontRule: true,
    ruleType: VALUE_TYPE,
    isMultipleRule: true,

    options: [MAX_DATE, MIN_DATE, DATE_ALLOWED, DATE_NOT_ALLOWED, WEEKEND_NOT_ALLOWED, RANGE],

    MAX_DATE: [MAX_DATE],
    MIN_DATE: [MIN_DATE],
    DATE_ALLOWED: [DATE_ALLOWED],
    DATE_NOT_ALLOWED: [DATE_NOT_ALLOWED],
    WEEKEND_NOT_ALLOWED: [WEEKEND_NOT_ALLOWED],
    RANGE: [RANGE],
  },

  CURRENCY: {
    isUpfrontRule: true,
    ruleType: VALUE_TYPE,
    isMultipleRule: true,
    options: [CURRENCY_VALUE_EQUAL, CURRENCY_VALUE_NOT_EQUAL, CURRENCY_VALUE_LESS_THAN, CURRENCY_VALUE_LESS_THAN_AND_EQUAL, CURRENCY_VALUE_GREATER_THAN, CURRENCY_VALUE_GREATER_THAN_AND_EQUAL],

    CURRENCY_VALUE_EQUAL: [CURRENCY_VALUE_EQUAL],

    CURRENCY_VALUE_NOT_EQUAL: [CURRENCY_VALUE_NOT_EQUAL],  

    CURRENCY_VALUE_LESS_THAN: [CURRENCY_VALUE_LESS_THAN],

    CURRENCY_VALUE_LESS_THAN_AND_EQUAL: [CURRENCY_VALUE_LESS_THAN_AND_EQUAL],

    CURRENCY_VALUE_GREATER_THAN: [CURRENCY_VALUE_GREATER_THAN],

    CURRENCY_VALUE_GREATER_THAN_AND_EQUAL: [CURRENCY_VALUE_GREATER_THAN_AND_EQUAL]
  },
  TIME_PICKER: {
    isUpfrontRule: true,
    ruleType: VALUE_TYPE,
    isMultipleRule: true,

    options: [MAX_TIME, MIN_TIME, TIME_ALLOWED, TIME_NOT_ALLOWED],

    MAX_TIME: [MAX_TIME],

    MIN_TIME: [MIN_TIME],

    TIME_ALLOWED: [TIME_ALLOWED],

    TIME_NOT_ALLOWED: [TIME_NOT_ALLOWED],
  },
  DATE_TIME_PICKER: {
    isUpfrontRule: true,
    ruleType: VALUE_TYPE,
    isMultipleRule: true,

    options: [MAX_DATE_TIME, MIN_DATE_TIME, DATE_TIME_ALLOWED, DATE_TIME_NOT_ALLOWED],

    MAX_DATE_TIME: [MAX_DATE_TIME],

    MIN_DATE_TIME: [MIN_DATE_TIME],

    DATE_TIME_ALLOWED: [DATE_TIME_ALLOWED],

    DATE_TIME_NOT_ALLOWED: [DATE_TIME_NOT_ALLOWED],
  },

  MULTIPLE_CHOICE: {
    isUpfrontRule: true,
    ruleType: VALUE_TYPE,
    isMultipleRule: true,
    options: [MAX_OPTION, MIN_OPTION],

    MAX_OPTION: [MAX_OPTION],
    MIN_OPTION: [MIN_OPTION],
  },
  NUMBER_INPUT :{
    isUpfrontRule: true,
    ruleType: VALUE_TYPE,
    isMultipleRule: true,
    options: [
      NUMBER_VALUE_EQUAL,
      NUMBER_VALUE_LESS_THAN,
      NUMBER_VALUE_LESS_THAN_AND_EQUAL,
      NUMBER_VALUE_GREATER_THAN,
      NUMBER_VALUE_GREATER_THAN_AND_EQUAL,
      DIGIT_COUNT,
    ],
    MAX_OPTION: [MAX_OPTION],
    MIN_OPTION: [MIN_OPTION],
    NUMBER_VALUE_EQUAL:[NUMBER_VALUE_EQUAL],
    NUMBER_VALUE_LESS_THAN:[NUMBER_VALUE_LESS_THAN],
    NUMBER_VALUE_LESS_THAN_AND_EQUAL:[NUMBER_VALUE_LESS_THAN_AND_EQUAL],
    NUMBER_VALUE_GREATER_THAN:[NUMBER_VALUE_GREATER_THAN],
    NUMBER_VALUE_GREATER_THAN_AND_EQUAL:[NUMBER_VALUE_GREATER_THAN_AND_EQUAL],
    DIGIT_COUNT:[DIGIT_COUNT],
  },
};



export type RangeRuleValueConfigType = {
  min?: number;
  max?: number;
  isMinIncluded?: boolean;
  isMaxIncluded?: boolean;
};

export type FieldRuleValueConfig = number | string | RangeRuleValueConfigType;

export interface IFieldRuleConfig {
  rule: string;
  value?: FieldRuleValueConfig;
  errorMessage: string;
  subRules?: IFieldRuleConfig[];
  valueType?:"dynamic"| "static";
  dynamicValueFieldId?: string;
}

